export const defaultSearchScheduleLimit = 5;
export const minResultsToHideSuggestions = 10;
export const searchResultsPageSize = 10;
export const searchRequestTimeoutMs = 15_000;
